// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_errors_home_button = /** @type {(inputs: {}) => string} */ () => {
	return `Home`
};

const id_errors_home_button = /** @type {(inputs: {}) => string} */ () => {
	return `Rumah`
};

const ja_errors_home_button = /** @type {(inputs: {}) => string} */ () => {
	return `家`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_home_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_home_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_home_button", locale)
	if (locale === "en") return en_errors_home_button(inputs)
	if (locale === "id") return id_errors_home_button(inputs)
	return ja_errors_home_button(inputs)
};
export { errors_home_button as "errors.home_button" }